import swal from "sweetalert"

function ValidateEmail(mail) {
  var regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  if (regex.test(mail)) return true
  else if (mail.length <= 0) {
    swal({
      title: "warning",
      text: "Email Cannot Be Empty",
      icon: "warning"
    })
  } else {
    swal({
      title: "warning",
      text: "You have entered an invalid email address!",
      icon: "warning"
    })
  }
  return false
}

function notEmpty(msg) {
  if (msg.length > 0) return true
  else {
    swal({
      title: "warning",
      text: "Field Cannot Be Empty",
      icon: "warning"
    })
    return false
  }
}
function allLetter(inputtxt, name) {
  var letters = /^[A-Za-z ]+$/
  if (letters.test(inputtxt)) return true
  else if (inputtxt.length <= 0) {
    swal({
      title: "warning",
      text: `${name} Cannot Be Empty`,
      icon: "warning"
    })
  } else {
    swal({
      title: "warning",
      text: `${name} Containes Only Letters`,
      icon: "warning"
    })
  }
  return false
}

function checkSpecial(inputtxt) {
  let letters = /^[A-Za-z0-9 ]+$/
  if (letters.test(inputtxt)) return true
  else if (inputtxt.length <= 0) {
    swal({
      title: "warning",
      text: "Field Cannot Be Empty",
      icon: "warning"
    })
  } else {
    swal({
      title: "warning",
      text: "Special Characters Not Allowed",
      icon: "warning"
    })
  }
  return false
}

function onlyDigit(input) {
  let letters = /^[0-9 ]+$/
  if (letters.test(input)) return true
  else if (input.length <= 0) {
    swal({
      title: "warning",
      text: "Percentage Cannot Be Empty",
      icon: "warning"
    })
  } else {
    swal({
      title: "warning",
      text: "Only Digits Are Allowed",
      icon: "warning"
    })
  }
  return false
}

export { notEmpty, allLetter, ValidateEmail, checkSpecial, onlyDigit }
